import api from "../../utils/apiUser";

export const getUsuarios = async (page = 1, limit = 20, usuario = "", correo = "") => {
  try {
    const res = await api.get("/api/acceso", {
      params: { page, limit, usuario, correo },
    });

    return res.data;
  } catch (err) {
    console.error("Error al obtener usuarios:", err);
    throw err;
  }
};

export const crearUsuario = async (usuarioData) => {
  const res = await api.post("/api/acceso", usuarioData);
  return res.data;
};

export const updateUser = async (id, data) => {
  const res = await api.put(`/api/acceso/${id}`, data);
  return res.data;
};
